/*@flow*/
import hasOwn from 'lib/hasOwn';

export default function hasProperty(o: Object, k: string): %checks {
  return hasOwn.call(o, k);
}
